import React from 'react';

type GridProps = {
	children?: React.ReactNode;
	className?: string;
	"data-name"?: string;
	style?: React.CSSProperties;
}

const Grid = React.forwardRef<HTMLDivElement, GridProps>((props, ref) =>
{
	return (
		<div
			ref={ref}
			className={[
				"layoutGrid",
				(props.className ? props.className : ""),
			].join(' ')}
			style={props.style}
		>
			{props.children}
		</div>
	);
});

export default Grid;